import { useEffect } from 'react';
import { useSEO } from '../context/SEOContext';

export default function SEOMeta({ path }) {
  const { getSEO } = useSEO();
  const seo = getSEO(path);

  useEffect(() => {
    // Title
    document.title = seo.title;

    // Meta description
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) { desc = document.createElement('meta'); desc.name = 'description'; document.head.appendChild(desc); }
    desc.content = seo.description;

    // Meta keywords
    let kw = document.querySelector('meta[name="keywords"]');
    if (!kw) { kw = document.createElement('meta'); kw.name = 'keywords'; document.head.appendChild(kw); }
    kw.content = seo.keywords;

    // Open Graph
    const og = { 'og:title': seo.title, 'og:description': seo.description, 'og:type': 'website' };
    Object.entries(og).forEach(([prop, content]) => {
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute('property', prop); document.head.appendChild(el); }
      el.content = content;
    });

    // Canonical
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) { canon = document.createElement('link'); canon.rel = 'canonical'; document.head.appendChild(canon); }
    canon.href = `${window.location.origin}${path}`;

    // Schema.org JSON-LD
    let schema = document.getElementById('page-schema');
    if (!schema) { schema = document.createElement('script'); schema.id = 'page-schema'; schema.type = 'application/ld+json'; document.head.appendChild(schema); }
    schema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': path === '/' ? 'WebSite' : 'WebPage',
      name: seo.title,
      description: seo.description,
      url: `${window.location.origin}${path}`,
      publisher: { '@type': 'Organization', name: 'Apnaa Calculator', url: window.location.origin },
    });
  }, [seo, path]);

  return null;
}
